import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlatformDetectionService {
  /**
   * Detects if the current device is iOS
   * @returns boolean indicating if the device is iOS
   */
  isIOS(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();

    // Check for iOS devices
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    // Additional check for iPadOS 13+ which reports as macOS
    const isIPadOS = /macintosh/.test(userAgent) && 'ontouchend' in document;

    return isIOS || isIPadOS;
  }

  /**
   * Detects if the current device is mobile
   * @returns boolean indicating if the device is mobile
   */
  isMobile(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
  }

  /**
   * Detects if the current device is Android
   * @returns boolean indicating if the device is Android
   */
  isAndroid(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();
    return /android/.test(userAgent);
  }

  /**
   * Gets the current platform name
   * @returns string indicating the platform
   */
  getPlatform(): 'ios' | 'android' | 'desktop' {
    if (this.isIOS()) {
      return 'ios';
    } else if (this.isAndroid()) {
      return 'android';
    } else {
      return 'desktop';
    }
  }
}
